import { createContext } from 'react'
import { UsersContext } from './contextTypes' 
export default createContext<UsersContext | null>(null)